import { useMemo } from 'react';
import { useI18n } from '../../../i18n';
import type { SupportedLanguage } from '@cubemeet/core/i18n';
import { translateSettings } from '@cubemeet/core/modules/settings/i18n';

export const useSettingsTranslation = (overrideLanguage?: SupportedLanguage) => {
  const { language } = useI18n();
  const activeLanguage = overrideLanguage || language;

  const t = useMemo(() => {
    return (key: string, params?: Record<string, any>) => translateSettings(activeLanguage, key, params);
  }, [activeLanguage]);

  return { t, language };
};
